<template>
  <div class="default-modal is-show" style="display: block;" @click="close()">
    <div class="default-modal__bg js-default-modal-close"></div>
    <div class="default-modal__content l-tutorial" style="width: 970px;" @click="stopEvent()">
      <div class="default-modal__header">
        <a class="default-modal__close js-default-modal-close"  @click="close()"></a>
      </div>
      <div class="default-modal__body">
        <div class="l-headding is-blueline">チュートリアル</div>
        <div class="l-tutorial__canvas"><img src="@/assets/img/tutorial/tutorial07.svg" width="910" height="555" alt=""></div>
        <div class="default-modal__footer">
          <div class="l-grayBox">
            <label class="l-checkbox">
              <input type="checkbox" v-model="isNotDisplayedTutorial"> このチュートリアルを今後表示しない。
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isNotDisplayedTutorial: false, 
    }
  },
  methods: {
    close() {
      if (this.isNotDisplayedTutorial) {
        this.$store.dispatch('auth/setIsShowDiagResultTutorial', false);
        this.$axios.post('/ld/api/user/updateIsShowTutorial', {
          isShowDiagResultTutorial: this.isNotDisplayedTutorial,
        });
      }
      this.$emit("close-tutorial-modal");
    },
    stopEvent() {
      event.stopPropagation()
    }
  },
}


</script>